import { html } from 'lit';
import store from '@mfe/store';
import service from '@mfe/service';
import { TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION } from '@mfe/service/tracker';
import { saveAndLoad, cancelEditMode } from '@mfe/store/consents';
import { ConsentGroup } from '@mfe/types/common';

export const viewTemplate = (
  consentGroup: ConsentGroup,
  editmodeActiveGroupInd: number,
  changesMade: boolean,
) => html`
          <div class="section">
            <tef-coms-consent-group
              .consentGroup=${consentGroup}
              .groupIndex=${editmodeActiveGroupInd}
            ></tef-coms-consent-group>
          </div>
          <div class="section section-buttons">
            <div class="form-row form-row--buttons">
               <button
                  class="button button-border"
                  @click=${
  () => {
    store.dispatch(cancelEditMode());
    service.tracker.doTracking(
      TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION,
      {
        group:
                            consentGroup.name
                            || 'noname',
      },
    );
  }
}
               >
                  Abbrechen
               </button>
               <button
                 class="button button-default"
                 data-test-id="save"
                .disabled=${!changesMade}
                data-disabled=${!changesMade}
                @click=${
  () => {
    store.dispatch(saveAndLoad());
  }
}
               >
                  Speichern
               </button>
            </div>
          </div>
          `;

export default viewTemplate;
